<template>
  <em-z-tree ref="locationTree" :treeNodes="locationTreeNodes" :chkboxType="chkboxType" textKeys="name" checkEnable :multiSelect="enableMulti">
  </em-z-tree>
</template>
<script>
// Author YuJiaBei
// Date 2020-10-8 14:25:08

import EmZTree from "@/components/em/EmZTree";
import EmCommonApi from "@/mixin/em/common/api";

export default {
  name: "locationTree",
  mixins: [EmCommonApi],
  components: {EmZTree},
  props: {
    enableMulti: {
        type: Boolean,
        default: false
    }
  },
  data() {
    return {
      locationTreeNodes: [],
      chkboxType: {"Y": "s", "N": "s"} //父节点可以连带子节点，子节点不连带父节点
    }
  },
  methods: {
    getLocationTreeNodes() {
      this.$_emApiMixin_findByFilter("sithMesMstLocation", {})
                .then(data => {
                    this.locationTreeNodes = data
                })
    },
    getLocationIds() {
      let locationNodes = this.$refs['locationTree'].getCheckedNodes()
      var v = "";
      for (var i = 0; i < locationNodes.length; i++) {
        v += "," + locationNodes[i].id
      }
      return v.length > 0 ? v.substring(1) : v;
    }
  },
  mounted() {
    this.getLocationTreeNodes();
  }
};
</script>